<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>

                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="px-8 pt-8 login-tabs-container">
                                <div class="vx-card__title mb-4">
                                    <vs-tabs>
                                        <vs-tab label="Bedrijven">
                                            <ht-company-login></ht-company-login>
                                        </vs-tab>
                                        <vs-tab label="Hebtrek">
                                            <ht-staff-login></ht-staff-login>
                                        </vs-tab>
                                    </vs-tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import HtStaffLogin from './Staff';
import HtCompanyLogin from './Company';
export default {
    components: {
        HtStaffLogin,
        HtCompanyLogin
    },
    data() {
        return {}
    }
}
</script>
